/**
 * Authenticated asset download (feature: descargar imágenes).
 *
 * A cross-origin `<a download>` is ignored by the browser (CORS), so instead
 * this fetches the file through the authenticated API as a blob, mints a
 * same-origin objectURL, and clicks a throwaway anchor against that URL —
 * which always downloads regardless of where the API is hosted.
 */
import { toast } from 'sonner';
import axiosInstance from './axios';

export async function downloadAsset(path, filename) {
  try {
    const res = await axiosInstance.get('/images/download', {
      params: { path },
      responseType: 'blob',
    });
    const objectUrl = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = filename || path.split('/').pop() || 'imagen';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(objectUrl);
  } catch (err) {
    console.error('Failed to download asset', path, err);
    toast.error('Error al descargar la imagen');
  }
}
